var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTheMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.5 425.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #fff200;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.33,
    y1: 290.95,
    x2: 211.65,
    y2: 290.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 301.07,
    y1: 152.31,
    x2: 211.65,
    y2: 290.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 264.29,
    y1: 21.65,
    x2: 301.07,
    y2: 152.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.33,
    y1: 290.95,
    x2: 112.31,
    y2: 382.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 258.56,
    y1: 401.61,
    x2: 112.31,
    y2: 382.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 389.17,
    y1: 269.5,
    x2: 258.56,
    y2: 401.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 374.22,
    y1: 108.06,
    x2: 389.17,
    y2: 269.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 264.29,
    y1: 24.33,
    x2: 374.22,
    y2: 108.06
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.9 302.35 202.94 290.95 191.9 279.54 207.29 283.4 211.65 268.14 216 283.4 231.4 279.54 220.36 290.95 231.4 302.35 216 298.49 211.65 313.75 207.29 298.49 191.9 302.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "281.32 163.72 292.36 152.31 281.32 140.91 296.71 144.77 301.07 129.51 305.42 144.77 320.82 140.91 309.78 152.31 320.82 163.72 305.42 159.86 301.07 175.12 296.71 159.86 281.32 163.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.98 172.4 148.02 160.99 136.98 149.59 152.37 153.45 156.73 138.19 161.08 153.45 176.48 149.59 165.44 160.99 176.48 172.4 161.08 168.54 156.73 183.8 152.37 168.54 136.98 172.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.33 269.5 30.12 285.15 45.78 290.95 30.12 296.74 24.33 312.4 18.54 296.74 2.88 290.95 18.54 285.15 24.33 269.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "264.29 2.88 270.08 18.54 285.74 24.33 270.08 30.12 264.29 45.78 258.49 30.12 242.84 24.33 258.49 18.54 264.29 2.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "374.22 86.61 380.01 102.27 395.67 108.06 380.01 113.85 374.22 129.51 368.43 113.85 352.77 108.06 368.43 102.27 374.22 86.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.17 248.05 394.96 263.71 410.62 269.5 394.96 275.29 389.17 290.95 383.38 275.29 367.72 269.5 383.38 263.71 389.17 248.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "258.56 380.16 264.36 395.81 280.01 401.61 264.36 407.4 258.56 423.05 252.77 407.4 237.11 401.61 252.77 395.81 258.56 380.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.31 361.49 118.1 377.15 133.75 382.94 118.1 388.73 112.31 404.39 106.51 388.73 90.86 382.94 106.51 377.15 112.31 361.49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheMoon);
export default __webpack_public_path__ + "static/media/TheMoon.bda33f418a9271eb7bb05966951d0c2b.svg";
export { ForwardRef as ReactComponent };